'use strict';
$(function () {
	$('.layout-left__inner').fitSidebar({
		wrapper: ".layout-container",
		responsiveWidth: 800
	});

	/**
	 * scroll
	 */
	$('a[href^="#"]').on('click ', function () {
		var $target = $($(this).attr('href'));
		$('html,body').animate({scrollTop: $target.offset().top}, 500);
		return false;
	});

	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 50) {
			$('.scrollTop__button').removeClass('scrollTop__button__hide');
		} else {
			$('.scrollTop__button').addClass('scrollTop__button__hide');
		}
	});

	/**
	 * history
	 */
	var tags = _.chain($('.timeline-item').get())
	.reduce(function (memo, elem) {
		var $elem = $(elem);
		var rights = _.map($elem.find('.note-media-rights').get(), function (elem) { return $(elem).text().replace(/ /, '-'); });
		_.each(rights, function (right) {
			$elem.addClass('tag-' + right);
		});
		return memo.concat(rights);
	}, [])
	.unique()
	.value().sort();

	var menutpl = require('./filter.ejs');
	var $html = $(menutpl({tags: tags}));
	var $buttons = $html.find('.filter-menu-button');
	$buttons.on('click', function () {
		var $this = $(this);
		var tag = $(this).data('tag');
		$this.toggleClass('filter-menu-button-on');
		var $items = $('.timeline-item').filter(function () {
			return $(this).hasClass('tag-' + tag);
		});
		if ($this.hasClass('filter-menu-button-on')) {
			$items.css('display', '');
		} else {
			$items.css('display', 'none');
		}
		return false;
	});

	$('.filter-menu-toggle', $html).on('click', function () {
		$('.filter-menu-body').toggleClass('filter-menu-body-close');
		return false;
	})

	$('.region-filter').append($html);

	/**
	 * align height
	 */
	(function(){
		window.matchMediaSP = window.matchMedia('screen and (max-width: 640px)');
		matchMediaSP.addListener(fixHeight);
		$(window).on('resize', fixHeight);
		fixHeight();
	})();

	/**
	 * mailto
	 */
	(function(){
		var cr = window.cr = require('crypto-js');
		var str = 'U2FsdGVkX1+eDBqzl9QvgV24QO9sTp9SQf3wqyxR3yY=';
		$('.mailto').on('click', function(){
			window.location.href = 'mailto:'+cr.AES.decrypt(str, 'ryorca.net').toString(cr.enc.Utf8);
			return false;
		});
	})();
});

function fixHeight(){
	$('.history-music .__content-head').css('height', '');
	$('.history-music .__content__note-list').css('height', '');
	$('.history-translate .__content-head').css('height', '');
	$('.history-translate .__content__note-list').css('height', '');
	if(!window.matchMediaSP.matches){
		alignHeight('.history-music .__content-head', 3);
		alignHeight('.history-music .__content__note-list', 3);
		alignHeight('.history-translate .__content-head', 3);
		alignHeight('.history-translate .__content__note-list', 3);
	}
}

function _alignHeight(selector){
	var $elems = $(selector);
	var height = _.reduce($elems, function(memo, elem){
		return Math.max(memo,$(elem).height());
	}, 0);
	$elems.css('height', height);
};

function alignHeight(selector, step){
	if( !step ) return _alignHeight(selector);
	_.chain($(selector))
	.reduce(function(memo, item, idx, arr){
		if(idx % step === 0){
			memo.push( arr.slice( idx, idx + step ) )
		}
		return memo;
	}, [])
	.each(function(item){
		_alignHeight(item);
	});
}
var moreHistory = require('./more-history');
$(function(){

	function createList(json){
		var data = _.rest(json, 3);
		_( data.length % 3).times(function(){
			data.push(null);
		});

		var html = _(data).reduce(function(memo, obj){
			return memo + moreHistory(obj);
		}, "");

		return html;
	}

	$('#__more-history-music').on('click', function(){
		var $this = $(this);
		$.getJSON('/assets/json/groups.json').done(function(json){
			$('.history-music .history-list').append(createList(json));
			$this.off('click').remove();
			fixHeight();
		});
	});

	$('#__more-history-translate').on('click', function(){
		var $this = $(this);
		$.getJSON('/assets/json/groups-translate.json').done(function(json){
			$('.history-translate .history-list').append(createList(json));
			$this.off('click').remove();
			fixHeight();
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./htdocs/assets/js/_src/index.js
// module id = 1
// module chunks = 0